import { render, staticRenderFns } from "./EditPromo.vue?vue&type=template&id=596e26fd&scoped=true&"
import script from "./EditPromo.vue?vue&type=script&lang=js&"
export * from "./EditPromo.vue?vue&type=script&lang=js&"
import style0 from "./EditPromo.vue?vue&type=style&index=0&id=596e26fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596e26fd",
  null
  
)

export default component.exports